import { styled } from '@mui/material/styles';

const StyledWrapper = styled('div')(
  ({ theme, $imgPositionDesktop }) => `
   display : flex;
   flex-direction: column;
   gap: ${theme.DS_spacing(['md'])};
     .gatsby-image-wrapper{
        max-height: 520px;
     }
 
   ${theme.breakpoints.up('lg')} {
     margin: ${theme.DS_spacing(['md'])} 0;
     flex-direction: ${$imgPositionDesktop ? `row-reverse` : `row`};
        > * {
          flex-basis: 50%;
        }
       .gatsby-image-wrapper{
          max-height: unset;
          img {
            margin-top: 0;
          }
       }
  
     }
  `,
);

export { StyledWrapper };
